export default "__VITE_ASSET__6e2a46ef__"